module.exports = __webpack_public_path__ + "img/kovarex-enrichment-process.ed8ea962.png";